import React, { useContext } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBackOutlined, Menu as MenuIcon } from "@mui/icons-material";
import { CreatorContext } from "../../context/CreatorContext";

const ShowcaseTopBar = ({
	logo,
	title,
	showDrawer,
	showArrow,
	onMenuClick,
	showPayment,
}) => {
	const { creator } = useContext(CreatorContext);

	function hexToRGBA(hex, opacity) {
		let r = parseInt(hex.slice(1, 3), 16);
		let g = parseInt(hex.slice(3, 5), 16);
		let b = parseInt(hex.slice(5, 7), 16);

		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				padding: "8px",
				paddingBottom: "6px",
				position: "sticky",
				top: 0,
				zIndex: 1000,
				backgroundColor: creator.topbarColor,
				height: "44px",
				borderTopRightRadius: "26px",
				borderTopLeftRadius: "26px",
				paddingTop: "28px",
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			{showDrawer ? (
				<IconButton
					aria-label="menu"
					sx={{
						fontSize: "12px",
						color: creator.topbarTextColor,
						padding: 0,
						width: "12px",
						height: "12px",
						zIndex: 1000,
					}}
					onClick={() => {
						onMenuClick();
					}}
				>
					<MenuIcon
						sx={{
							fontSize: "12px",
							color: creator.topbarTextColor,
						}}
					/>
				</IconButton>
			) : (
				<ArrowBackOutlined
					sx={{
						fontSize: "12px",
						opacity: showArrow ? 1 : 0,
						color: creator.topbarTextColor,
					}}
				/>
			)}
			<Box sx={{ display: "flex", alignItems: "center" }}>
				{logo ? (
					<img
						src={logo}
						alt="Logo"
						style={{ height: "10px", maxWidth: "120px", objectFit: "contain" }}
					/>
				) : (
					<Typography
						variant="h6"
						sx={{
							fontWeight: 400,
							fontSize: "8px",
							textTransform: "inherit",
							color: creator.topbarTextColor,
							fontFamily: creator.fontFamilyCap + "!important",
						}}
					>
						{title}
					</Typography>
				)}
			</Box>
			<ArrowBackOutlined sx={{ opacity: 0, fontSize: "12px" }} />
			{showPayment && (
				<Box
					sx={{
						position: "absolute",
						bottom: 0,
						left: 0,
						right: 0,
						top: 0,
						backgroundColor: hexToRGBA("#000000", 0.5),
					}}
				></Box>
			)}
		</Box>
	);
};

export default ShowcaseTopBar;
